import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
const textStaticStyle = css({
    color: theme.text.main,
    fontFamily: tokens.fontFamilies.sansSerif,
    fontWeight: tokens.fontWeights.regular,
    lineHeight: tokens.lineHeights.relaxed,
    margin: 0,
    padding: 0,
});
export function textStyle({ size }) {
    return [
        textStaticStyle,
        css({
            fontSize: tokens.fontSizes[size],
        }),
    ];
}
